export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13701.4469ca30.jpg";